/* Suprimal: keeps the "Scratch for your offer" tab (sections/suprimal-scratch-welcome) out of the shopper's way.
   - The bag: while the bag drawer is open (opened by the shopper or after Add to bag) and on the bag page, the tab steps aside so
     nothing sits on top of Checkout. When the bag closes it comes back, but only if it was showing anyway: the pop-up's own rules
     (no email yet, not hidden with its close button) are untouched, this only covers the tab while the bag is up.
   - Bottom bars on phones: the product page's sticky buy bar and the build-a-stack bar. While one is showing and the two would
     overlap, the tab rises to sit 12px above it, then drops back when the bar hides.
   Loaded from layout/suprimal.liquid. */
(function () {
  var d = document, html = d.documentElement;
  var CSS = [
    /* the fade back in waits a moment, so the bag slides away first */
    '.spw .spw__teaser{transition:transform .45s var(--spw-ease),background-color .3s,opacity .3s ease .25s,visibility 0s linear .25s}',
    '.spw .spw__teaser-x{transition:opacity .3s ease .25s,transform .45s var(--spw-ease) .25s,visibility 0s linear .25s}',
    'html.sp-bag-open .spw .spw__teaser-wrap{pointer-events:none}',
    'html.sp-bag-open .spw .spw__teaser,html.sp-bag-open .spw .spw__teaser-x{opacity:0;visibility:hidden;transform:translateY(14px);transition:opacity .2s ease,transform .3s var(--spw-ease),visibility 0s linear .3s}',
    'html.sp-bag-page .spw .spw__teaser-wrap{display:none}',
    '@media (prefers-reduced-motion:reduce){html.sp-bag-open .spw .spw__teaser,html.sp-bag-open .spw .spw__teaser-x{transform:none}}'
  ].join('');
  function init() {
    var tab = d.querySelector('[data-spw-teaser]');
    if (!tab || tab.__spLift) return;
    tab.__spLift = 1;
    if (!d.getElementById('sp-offer-away')) {
      var st = d.createElement('style'); st.id = 'sp-offer-away'; st.textContent = CSS;
      (d.head || html).appendChild(st);
    }
    if (d.querySelector('[data-sp-cart][data-mode="page"]')) html.classList.add('sp-bag-page');
    var bars = [].slice.call(d.querySelectorAll('.sp-sticky, .sp-sh-bar'));
    if (!bars.length) return;
    var t;
    tab.style.transition = 'bottom .5s cubic-bezier(.2,.7,.1,1)';
    function barTop(b) {
      if (b.hidden || (b.classList.contains('sp-sh-bar') && !b.classList.contains('is-in'))) return 0;
      var cs = getComputedStyle(b);
      if (cs.display === 'none' || cs.position !== 'fixed') return 0;
      return (parseFloat(cs.bottom) || 0) + b.offsetHeight;
    }
    function lift() {
      if (tab.hidden) return;
      var r = tab.getBoundingClientRect(), need = 0;
      bars.forEach(function (b) {
        var top = barTop(b), br = b.getBoundingClientRect();
        if (top && br.left < r.right && br.right > r.left) need = Math.max(need, top);
      });
      tab.style.bottom = need ? Math.round(need + 12) + 'px' : '';
    }
    function soon(ms) { clearTimeout(t); t = setTimeout(lift, ms); }
    var watch = new MutationObserver(function () { soon(30); });
    bars.forEach(function (b) { watch.observe(b, { attributes: true, attributeFilter: ['hidden', 'class'] }); });
    watch.observe(tab, { attributes: true, attributeFilter: ['hidden'] });
    window.addEventListener('resize', function () { soon(120); });
    lift();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
